import { render } from "./mvt-sharelink.vue?vue&type=template&id=599ae9b4"
import script from "./mvt-sharelink.js?vue&type=script&lang=js"
export * from "./mvt-sharelink.js?vue&type=script&lang=js"

import "./mvt-sharelink.vue?vue&type=style&index=0&id=599ae9b4&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__